<!--
 * @Author: lsh
 * @Date: 2021-03-01 14:20:20
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-22 16:54:43
 * @Descripttion: 
 * @FilePath: \scwater_development\src\views\projectOnly\investManage\TapIndex.vue
-->
<template>
  <div class="index-wrap">
    <h2>投资管理</h2>
    <div class="tap-wrap">
      <span
        v-for="(item, index) in tapData"
        :key="index"
        @click="handleClick(item)"
        :class="{ active: tapIndex == item.name }"
      >{{ item.name }}</span>
      <div class="line"></div>
    </div>
    <div class="item-wrap">
      <invest-plan v-if="tapIndex == '投资计划'"></invest-plan>
      <invest-in-place v-if="tapIndex == '到位投资'"></invest-in-place>
    </div>
  </div>
</template>

<script>
import  InvestPlan from './components/InvestPlan.vue'
import investInPlace from './components/InvestInPlace.vue'

export default {
  name: "Taplndex",
  components:{
InvestPlan,
investInPlace
  },

  data() {
    return {
      tapData: [
       
        {
          name: "投资计划",
        },
        {
          name: "到位投资",
        },
      
      ],
      tapIndex: "投资计划",
    };
  },
  created() {},
  mounted() {
    let type = this.$route.query.type;
    if (type == "4") {
      this.tapIndex = "投资完成情况统计";
    }
  },
  methods: {
    handleClick(item) {
      this.tapIndex = item.name;
    },
  },
};
</script>
<style lang='scss' scoped>
.index-wrap {
  height: 100%;
  background-color: #ffffff;
  h2 {
    font-size: 20px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 600;
    padding-left: 20px;
    margin: 5px 0;
  }
  .tap-wrap {
    padding: 0 20px;
    border-bottom: 1px solid #e8e8e8;
    span {
      display: inline-block;
      padding: 14px 0px;
      margin-right: 40px;
      color: rgba(0, 0, 0, 0.85);
      cursor: pointer;
      font-weight: 500;
      font-size: 16px;
      &.active {
        color: #333;
        border-bottom: 2px solid #008dfe;
      }
    }
  }
  .item-wrap {
    background: #f7f8f9;
    padding: 0 20px;
  }
}
</style>
